module.exports = __webpack_public_path__ + "static/media/separations.8a359284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/separations.svg
// module id = 213
// module chunks = 0